import { sideBarLogo, sidebarLogoStyles } from '../config';

const SidebarLogo = () => {
  return <img src={sideBarLogo} style={sidebarLogoStyles} alt="sidebar logo" />;
};

export default SidebarLogo;
